<script>
import { TeleportBus } from './teleport-bus'

/**
 * <Teleport to="nome"> — origem do teleport.
 *
 * Não renderiza nada no lugar; publica os vnodes do seu slot no TeleportBus sob
 * `to`, e o `<TeleportTarget name="nome">` os renderiza em outro ponto da
 * árvore. Como o conteúdo continua sendo criado no contexto da view (origem),
 * os handlers/refs (`@apply`, `@click`, etc.) seguem ligados à própria view —
 * por isso o filtro continua "dentro da view", igual ao padrão de hoje.
 *
 * Reatividade: quando a view re-renderiza (filtro muda), o slot muda -> o hook
 * `updated` republica -> o target re-renderiza.
 *
 * Unicidade: várias origens (ex: o filtro de cada rota do CRM) podem mirar o
 * mesmo `to`. Cada instância tem um `_ownerId`; o último a MONTAR assume a posse
 * (`claim`). `updated`/`beforeDestroy` só mexem no destino se ainda forem donos
 * (`update`/`release`) — um view saindo nunca sobrescreve/apaga o conteúdo de um
 * view que já assumiu o destino.
 */
// Id incremental por instância (dono do destino no bus).
let _teleportUid = 0

export default {
  name: 'Teleport',
  props: {
    to: {
      type: String,
      required: true,
    },
  },
  watch: {
    // Se o destino mudar em runtime, libera o antigo (se eu for o dono) e assume
    // a posse do novo.
    to(next, prev) {
      if (prev) TeleportBus.release(prev, this._ownerId)
      TeleportBus.claim(this.to, this._ownerId, this.$slots.default)
    },
  },
  created() {
    this._ownerId = ++_teleportUid
  },
  mounted() {
    // Assume a posse do destino (último a montar vence).
    TeleportBus.claim(this.to, this._ownerId, this.$slots.default)
  },
  updated() {
    // Republica SÓ se ainda for o dono (um view saindo não rouba o destino).
    TeleportBus.update(this.to, this._ownerId, this.$slots.default)
  },
  beforeDestroy() {
    // Libera SÓ se ainda for o dono (não apaga conteúdo de um view mais novo).
    TeleportBus.release(this.to, this._ownerId)
  },
  // Render vazio (comment node): a origem não ocupa espaço no lugar.
  render(h) {
    return h()
  },
}
</script>
